export const pageSize10 = 10;
export const pageSize20 = 20;
